import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration } from '../configs/api-configuration';

/**
 * Base class for services
 */
@Injectable({
  providedIn: 'root',
})
export class BaseService {
  protected config = inject(ApiConfiguration);
  protected http = inject(HttpClient);

  private _rootUrl = '';

  /**
   * Returns the root url for all operations in this service. If not set directly in this
   * service, will fallback to `ApiConfiguration.rootUrl`.
   */
  get rootUrl(): string {
    return this._rootUrl || this.config.rootUrl;
  }

  /**
   * Sets the root URL for API operations in this service.
   */
  set rootUrl(rootUrl: string) {
    this._rootUrl = rootUrl;
  }
}
